module.exports = __webpack_public_path__ + "img/gb-nir.gb-nir4e99cb8.svg";